import { useEffect, useState } from "react";

import useCustomSelector from "../../../redux/hooks/useCustomSelector";
import useActionCreator from "../../../redux/hooks/useActionCreator";

import { SharedTasksState } from "@reducers/types/taskManagement/shared-tasks-state";

interface UseSharedTasksList {
  sharedTasksState: SharedTasksState;
  handleQuery: (key: string, value: number | string) => void;
  clearSearch: () => void;
  hasFilter: boolean;
  query: any;
}

export const useSharedTasksList = (): UseSharedTasksList => {
  const { taskManagementActionsHandlers } = useActionCreator();
  const { sharedTasksFetchActionHandler } = taskManagementActionsHandlers;
  const [hasFilter, setHasFilter] = useState<boolean>(false);

  const [query, setQuery] = useState({
    page: 1,
    size: 10,
    search: "",
    status: "",
    startDate: "",
    endDate: "",
  });

  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const clearSearch = () => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      size: 10,
      search: "",
      status: "",
      startDate: "",
      endDate: "",
    }));
  };

  const sharedTasksState = useCustomSelector(
    (store) => store.taskManagement.sharedTasksState,
  );

  useEffect(() => {
    sharedTasksFetchActionHandler(query);

    if (query.search || query.status || query.startDate || query.endDate) {
      setHasFilter(true);
    } else {
      setHasFilter(false);
    }
  }, [query]);

  return {
    handleQuery,
    sharedTasksState,
    clearSearch,
    hasFilter,
    query,
  };
};
